<!--Author: Michał Pawłowski-->
<template>
  <a @click="back" class="float">
    <div class="back-arrow">
      <i class="fas fa-arrow-left" />
    </div>
  </a>
</template>

<script>
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// library.add(faArrowLeft);
export default {
  name: "FloationgBackButton",
  components: {
    // FontAwesomeIcon,
  },
  props: {},
  emits: ["backAction"],
  data() {
    return {};
  },
  computed: {
    availablePages() {
      var pages = [];
      for (let i = 0; i < this.pagesCount; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    back() {
      this.$emit("backAction", {});
    },
  },
  watch: {},
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}

body {
  font-family: Verdana, Geneva, sans-serif;
  font-size: 18px;
  background-color: #ccc;
}

.float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #292f41;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  z-index: 9999999;
}

.my-float {
  margin-top: 22px;
}

.back-arrow {
  display: block;
  position: absolute;
  top: 30%;
  left: 39%;
}
</style>
